import filter from "lodash.filter";
import sortBy from "lodash.sortby";
import { components } from "@salesforce/design-system-react/package.json";
import Snippets from "../../../node_modules/@salesforce/design-system-react/components/site-stories";

const componentsWithExamplesEntry = components.filter(
  item => Snippets[item.component]
);
const componentsStatusProd = filter(componentsWithExamplesEntry, {
  status: "prod"
});
const componentsStatusProdSorted = sortBy(componentsStatusProd, "display-name");
const componentsStatusPrototype = filter(componentsWithExamplesEntry, {
  status: "prototype"
});
const componentsStatusPrototypeSorted = sortBy(
  componentsStatusPrototype,
  "display-name"
);

export default { componentsStatusProdSorted, componentsStatusPrototypeSorted };



// WEBPACK FOOTER //
// ./public/src/utilities/library-parsers.js